const ExpertList = () => import('@/modules/expert/expertmanager/ExpertList.vue')
const ExpertBind = () => import('@/modules/expert/expertbind/ExpertBind.vue')
const CancelBindExpert = () => import('@/modules/expert/cancelbind/CancelBindExpert.vue')
const ExpertListAdmin = () => import('@/modules/expert/expertmanager/ExpertListAdmin')
const goodsTypeList = () => import('@/modules/goodsTypeManage/goodsTypeList')
const gernalGoogslist = () => import('@/modules/goodsTypeManage/gernalGoogslist')
const lymanager = () => import('@/modules/goodsTypeManage/lymanager')
const PageExpertScoringModel =() => import('@/modules/expert/expertscore/PageExpertScoringModel')
const PageExpertScoringProjects = () => import('@/modules/expert/expertscore/PageExpertScoringProjects')
export default [
  {

    path: '/expert',
    name: 'expertinfo',
    component: ExpertList,
    meta: {
      title: '专家管理',
      isBlack: true
    },
  },
  {

    path: '/expertadmin',
    name: 'expertadmin',
    component: ExpertListAdmin,
    meta: {
      title: '专家管理管理员',
      isBlack: true
    },
  },
  {

    path: '/expertbind',
    name: 'expertbind',
    component: ExpertBind,
    meta: {
      title: '专家绑定',
      isBlack: true
    },
  },
  {

    path: '/cancelbind',
    name: 'cancelbind',
    component: CancelBindExpert,
    meta: {
      title: '专家解绑',
      isBlack: true
    },
  },
  {

    path: '/goodsTypeList',
    name: 'goodsTypeList',
    component: goodsTypeList,
    meta: {
      title: '商品类型管理',
      isBlack: true
    },
  },
  {

    path: '/gernalGoogslistTwo',
    name: 'gernalGoogslist',
    component: gernalGoogslist,
    meta: {
      title: '商品列表',
      isBlack: true
    },
  },
  {

    path: '/lymanager',
    name: 'lymanager',
    component: lymanager,
    meta: {
      title: '留言管理',
      isBlack: true
    },
  },
  {
    path: '/scoringModel',
    name: 'scoringModel',
    component: PageExpertScoringModel,
    meta: {
      title: '打分模型管理',
      isBlack: true
    },
  },
  {
    path: '/scoringProjects',
    name: 'scoringProjects',
    component: PageExpertScoringProjects,
    meta: {
      title: '打分项目管理',
      isBlack: true
    },
  },
]
